import React from "react";

const OurPartners = () => {
  return (
    <div className="w-full bg-blue-50 pt-8 pb-20">
      <div className="max-w-6xl mx-auto w-full lg:px-0">
        <div className="container mx-auto w-full py-8 px-4 lg:px-0">
          <h1 className="text-center text-4xl md:text-5xl font-medium mb-16 text-primary">
            Our Partners
          </h1>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/62-e81392a98faf6f024db3e146e3d85250874a6302.png"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/111-912c36205e309541cb98b6bca76cc521e30c7679.jpg"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/561-8d5bfb7f982bf1bfea23727e09ab50b4eb52415c.png"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/347-81ccbff0ba946bb7dfedd0ed5137b437db6cab65.jpg"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/502-5f428229bc849d839a0becd5e93894a6bac2f952.jpg"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/690-013e18c12ff6c69601d96cdaf8717bce4fc68545.png"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/556-717612b9178c4c4eaa386c3d897a0665e3347e8a.png"
                alt=""
              />
            </div>
            <div className="w-full bg-white mx-auto text-center p-5 border border-gray-10 shadow-sm rounded-sm">
              <img
                className="mx-auto"
                src="https://www.bike-components.de/assets/m/logo/sg1/29-3a4aa59a9b0fc3327169aa21dbb35c5853c216a3.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurPartners;
